<div
  class="add-dialog-container"
  [ngClass]="{
    'dark-theme': _isDarkTheme,
    'light-theme': _isLightTheme,
    'paper-theme': _isPaperTheme,
    'mobile-sheet-mode': isMobileSheet,
  }"
>
  @if (_isDialogLoading) {
    <div class="loading-container">
      <div class="loading-spinner">
        <mat-spinner diameter="50"></mat-spinner>
      </div>
    </div>
  } @else {
    <div class="add-dialog-container-main">
      <!-- ! Options -->
      <div *ngIf="!_wordCreated && !_pairCreated && !_noteCreated">
        @if (_hasDic) {
          <div style="margin-bottom: 10px; display: flex; justify-content: start">
            <ddc-text-gradient
              class="text-xl"
              [_icon]="'auto_stories'"
              [_text]="_targetDicTitle"
              [_type]="'1'"
            ></ddc-text-gradient>
          </div>
        }
        <mat-chip-listbox
          class="theme-chip-listbox"
          aria-label="option selection"
          [ngClass]="{
            'dark-theme': _isDarkTheme,
            'light-theme': _isLightTheme,
            'paper-theme': _isPaperTheme,
          }"
          [(ngModel)]="_selectedChipOptions"
        >
          <mat-chip-option class="add-option" [value]="'word'"
            ><mat-icon matChipAvatar>fiber_manual_record</mat-icon>Word</mat-chip-option
          >
          <mat-chip-option class="add-option" [value]="'pair'"
            ><mat-icon matChipAvatar>fiber_smart_record</mat-icon>Pair</mat-chip-option
          >
          <mat-chip-option class="add-option" *ngIf="!_hasDic" [value]="'dictionary'"
            ><mat-icon matChipAvatar>auto_stories</mat-icon>Dictionary</mat-chip-option
          >
          <mat-chip-option class="add-option" *ngIf="!_hasDic" [value]="'note'"
            ><mat-icon matChipAvatar>text_snippet</mat-icon>Note</mat-chip-option
          >
          <mat-chip-option class="add-option" *ngIf="!_hasDic" [value]="'quiz'"
            ><mat-icon matChipAvatar>question_answer</mat-icon>Quiz</mat-chip-option
          >
          <mat-chip-option class="add-option" *ngIf="!_hasDic" [value]="'figure'"
            ><mat-icon matChipAvatar>hub</mat-icon>Figure</mat-chip-option
          >
        </mat-chip-listbox>
      </div>
      <mat-divider
        *ngIf="!_wordCreated && !_pairCreated && !_noteCreated"
        style="margin-bottom: 10px; margin-top: 10px"
      ></mat-divider>
      <!-- ! Add Form -->
      <form class="add-dialog-form" [formGroup]="_form">
        <!-- ! Form Error -->
        @if (_form.errors || _addError) {
          <div class="alert alert-danger">
            <div>{{ _addError }}</div>
            @if (_isSubscriptionError) {
              <ddc-button-u-one
                [_dynamicRoute]="'/pricing'"
                [_hasBorder]="true"
                [_icon]="'auto_awesome'"
                [_label]="'Upgrade'"
                (click)="closeDialog()"
              ></ddc-button-u-one>
            }
          </div>
        }
        @if (_wordCreated || _pairCreated || _noteCreated) {
          <div>
            <div class="alert alert-success success-msg">
              <div>
                <ng-lottie width="30px" [options]="options"></ng-lottie>
              </div>
              @if (_wordCreated && _addedField) {
                <div>&nbsp;&nbsp;&nbsp;Word "{{ _addedField }}" has been added.</div>
              }
              @if (_pairCreated && _addedField && _addedField2) {
                <div>&nbsp;&nbsp;&nbsp;Pair "{{ _addedField }}"="{{ _addedField2 }}" has been added.</div>
              }
              @if (_noteCreated && _addedField) {
                <div>&nbsp;&nbsp;&nbsp;Note "{{ _addedField }}" has been created.</div>
              }
            </div>
          </div>
        } @else {
          <div class="add-dialog-both-container">
            <!-- * Word 1 Container -->
            <div
              class="add-dialog-first-container"
              *ngIf="
                !_selectedChipOptions.includes('dictionary') &&
                !_selectedChipOptions.includes('note') &&
                !_selectedChipOptions.includes('quiz') &&
                !_selectedChipOptions.includes('figure')
              "
              [ngClass]="{
                'first-container-border': _selectedChipOptions.includes('pair'),
              }"
            >
              <!-- ! Label 1 -->
              @if (_selectedChipOptions.includes('pair')) {
                <ddc-text-gradient class="text-2xl" [_text]="'From'" [_type]="'1'"></ddc-text-gradient>
              }
              <!-- ! Language 1-->
              <div class="add-dialog-row-1 add-dialog-lng">
                <mat-form-field>
                  <mat-label><mat-icon>language</mat-icon>&nbsp;&nbsp;Language</mat-label>
                  <mat-select
                    formControlName="_1_language"
                    [(value)]="_selectedLanguage"
                    (selectionChange)="onLanguageChange($event)"
                  >
                    <mat-option *ngFor="let language of languages" [value]="language.raw_value">
                      {{ language.view_value }}
                    </mat-option>
                  </mat-select>
                  @if (lng1.hasError('required')) {
                    <mat-error> Required. </mat-error>
                  }
                </mat-form-field>
              </div>
              <!-- ! Article, Word, Pos 1-->
              <div class="add-dialog-row-2">
                <!-- Article 1-->
                <mat-form-field class="add-dialog-article">
                  <mat-label>Article</mat-label>
                  <mat-select
                    formControlName="_1_article"
                    name="article1"
                    [disabled]="!_selectedLngHasArticle"
                    [(value)]="_selectedArticle"
                  >
                    <mat-option
                      *ngFor="let article of articles"
                      [ngStyle]="{ 'background-color': article.view_value === 'None' ? 'rgb(231, 189, 189)' : '' }"
                      [value]="article.raw_value"
                    >
                      {{ article.view_value }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <!--  Word 1 -->
                <mat-form-field class="add-dialog-word">
                  <mat-label>Word</mat-label>
                  <input formControlName="_1_word" matInput placeholder="Ex. Apple" />
                  <!-- * Errors -->
                  @if (w1.hasError('maxlength')) {
                    <mat-error>
                      Maximum <strong>{{ _wordMaxlength }}</strong> characters.
                    </mat-error>
                  }
                  @if (w1.hasError('required')) {
                    <mat-error> Required. </mat-error>
                  }
                </mat-form-field>
                <!-- Pos 1 -->
                <mat-form-field class="add-dialog-pos">
                  <mat-label>Pos</mat-label>
                  <mat-select formControlName="_1_pos" [(value)]="_selectedPos">
                    <mat-option
                      *ngFor="let pos of poses"
                      [ngStyle]="{ 'background-color': pos.view_value === 'None' ? 'rgb(231, 189, 189)' : '' }"
                      [value]="pos.raw_value"
                    >
                      {{ pos.view_value }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <!-- ! Definition 1-->
              <div class="add-dialog-row-3">
                <mat-form-field class="add-dialog-definition">
                  <mat-label><mat-icon>description</mat-icon>&nbsp;&nbsp;Definition</mat-label>
                  <textarea
                    formControlName="_1_definition"
                    matInput
                    placeholder="Ex. The round fruit of a tree of the rose family"
                  ></textarea>
                  <!-- * Errors -->
                  @if (desc1.hasError('maxlength')) {
                    <mat-error>
                      Maximum <strong>{{ _definitionMaxlength }}</strong> characters.
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <!-- ! Example 1-->
              <div class="add-dialog-row-4">
                <mat-form-field class="add-dialog-example">
                  <mat-label><mat-icon>format_quote</mat-icon>&nbsp;&nbsp;Example</mat-label>
                  <textarea formControlName="_1_example" matInput placeholder="Ex. I ate an apple"></textarea>
                  <!-- * Errors -->
                  @if (exp1.hasError('maxlength')) {
                    <mat-error>
                      Maximum <strong>{{ _exampleMaxlength }}</strong> characters.
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <!-- ! Category 1-->
              <div class="add-dialog-cat">
                @if (_loadedCats) {
                  <ddc-elem-chooser-one
                    [_allElems]="_userCats"
                    [_elemType]="'category'"
                    [_label]="'Category'"
                    [_labelIcon]="'workspaces'"
                    [_placeholder]="'Select a Category'"
                    [_type]="'single'"
                    (selectedElemsChange)="updateSelectedCat($event)"
                  ></ddc-elem-chooser-one>
                }
              </div>
              <!-- ! Tags1 -->
              @if (_loadedTags) {
                <ddc-elem-chooser-one
                  [_allElems]="_userTags"
                  [_elemType]="'tag'"
                  [_label]="'Tags'"
                  [_labelIcon]="'sell'"
                  [_placeholder]="'Select tags...'"
                  [_type]="'multi'"
                  (selectedElemsChange)="updateSelectedTags($event)"
                ></ddc-elem-chooser-one>
              }
            </div>
            <!-- * Word 2 Container -->
            <div
              class="add-dialog-second-container"
              *ngIf="
                !_selectedChipOptions.includes('dictionary') &&
                !_selectedChipOptions.includes('note') &&
                !_selectedChipOptions.includes('quiz') &&
                !_selectedChipOptions.includes('figure')
              "
              [ngClass]="{
                'second-container-border': _selectedChipOptions.includes('pair'),
              }"
            >
              @if (_selectedChipOptions.includes('pair')) {
                <div>
                  <!-- ! Label 2 -->
                  <ddc-text-gradient class="text-2xl" [_text]="'To'" [_type]="'1'"></ddc-text-gradient>
                  <!-- ! Language 2-->
                  <div class="add-dialog-row-1 add-dialog-lng">
                    <mat-form-field>
                      <mat-label><mat-icon>language</mat-icon>&nbsp;&nbsp;Language</mat-label>
                      <mat-select
                        formControlName="_2_language"
                        [(value)]="_selectedLanguage2"
                        (selectionChange)="onLanguageChange2($event)"
                      >
                        <mat-option *ngFor="let language of languages2" [value]="language.raw_value">
                          {{ language.view_value }}
                        </mat-option>
                      </mat-select>
                      @if (lng2.hasError('required')) {
                        <mat-error> Required. </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <!-- ! Article, Word, Pos 2-->
                  <div class="add-dialog-row-6">
                    <!-- Article 2 -->
                    <mat-form-field class="add-dialog-article-2">
                      <mat-label>Article</mat-label>
                      <mat-select
                        formControlName="_2_article"
                        [disabled]="!_selectedLngHasArticle2"
                        [(value)]="_selectedArticle2"
                      >
                        <mat-option
                          *ngFor="let article of articles2"
                          [ngStyle]="{ 'background-color': article.view_value === 'None' ? 'rgb(231, 189, 189)' : '' }"
                          [value]="article.raw_value"
                        >
                          {{ article.view_value }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <!--  Word 2 -->
                    <mat-form-field class="add-dialog-word-2">
                      <mat-label>Word</mat-label>
                      <input formControlName="_2_word" matInput placeholder="Ex. Apple" />
                      <!-- * Errors -->
                      @if (w2.hasError('maxlength')) {
                        <mat-error>
                          Maximum <strong>{{ _wordMaxlength }}</strong> characters.
                        </mat-error>
                      }
                      @if (w2.hasError('required')) {
                        <mat-error> Required. </mat-error>
                      }
                    </mat-form-field>
                    <!-- Pos 2 -->
                    <mat-form-field class="add-dialog-pos-2">
                      <mat-label>Pos</mat-label>
                      <mat-select formControlName="_2_pos" [(value)]="_selectedPos2">
                        <mat-option
                          *ngFor="let pos of poses2"
                          [ngStyle]="{ 'background-color': pos.view_value === 'None' ? 'rgb(231, 189, 189)' : '' }"
                          [value]="pos.raw_value"
                        >
                          {{ pos.view_value }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <!-- ! Definition 2-->
                  <div class="add-dialog-row-7">
                    <mat-form-field class="add-dialog-definition-2">
                      <mat-label><mat-icon>description</mat-icon>&nbsp;&nbsp;Definition</mat-label>
                      <textarea
                        formControlName="_2_definition"
                        matInput
                        placeholder="Ex. The round fruit of a tree of the rose family"
                      ></textarea>
                      <!-- * Errors -->
                      @if (desc2.hasError('maxlength')) {
                        <mat-error>
                          Maximum <strong>{{ _definitionMaxlength }}</strong> characters.
                        </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <!-- ! Example 2-->
                  <div class="add-dialog-row-8">
                    <mat-form-field class="add-dialog-example-2">
                      <mat-label><mat-icon>format_quote</mat-icon>&nbsp;&nbsp;Example</mat-label>
                      <textarea formControlName="_2_example" matInput placeholder="Ex. I ate an apple"></textarea>
                      <!-- * Errors -->
                      @if (exp2.hasError('maxlength')) {
                        <mat-error>
                          Maximum <strong>{{ _exampleMaxlength }}</strong> characters.
                        </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <!-- ! Category 2-->
                  <div class="add-dialog-cat">
                    @if (_loadedCats) {
                      <ddc-elem-chooser-one
                        [_allElems]="_userCats"
                        [_elemType]="'category'"
                        [_label]="'Category'"
                        [_labelIcon]="'workspaces'"
                        [_placeholder]="'Select a Category'"
                        [_type]="'single'"
                        (selectedElemsChange)="updateSelectedCat2($event)"
                      ></ddc-elem-chooser-one>
                    }
                  </div>
                  <!-- ! Tags 2-->
                  @if (_loadedTags) {
                    <ddc-elem-chooser-one
                      [_allElems]="_userTags"
                      [_elemType]="'tag'"
                      [_label]="'Tags'"
                      [_labelIcon]="'sell'"
                      [_placeholder]="'Select tags...'"
                      [_type]="'multi'"
                      (selectedElemsChange)="updateSelectedTags2($event)"
                    ></ddc-elem-chooser-one>
                  }
                </div>
              }
            </div>
            <!-- * Dictionary Container -->
            <div class="add-dialog-dic-container" *ngIf="_selectedChipOptions.includes('dictionary')">
              <div class="add-dialog-ai-container">
                <div class="ai-only-message">
                  <mat-icon>auto_awesome</mat-icon>
                  <p>You can also generate a dictionary with Lingo AI.</p>
                </div>
                <ddc-button-ai
                  [_label]="'Generate Dictionary with AI'"
                  [_mode]="'dictionary'"
                  (click)="closeDialog()"
                ></ddc-button-ai>
              </div>
              <mat-divider style="margin: 12px 0"></mat-divider>
              <!-- ! Article, Word, Pos 1-->
              <!--  Title -->
              <mat-form-field>
                <mat-label>Title</mat-label>
                <input formControlName="_dictionary_title" matInput placeholder="Ex. Apple" />
                <!-- * Errors -->
                @if (w1.hasError('maxlength')) {
                  <mat-error>
                    Maximum <strong>{{ _wordMaxlength }}</strong> characters.
                  </mat-error>
                }
              </mat-form-field>
              <!-- ! Definition 1-->
              <mat-form-field>
                <mat-label><mat-icon>description</mat-icon>&nbsp;&nbsp;Definition</mat-label>
                <textarea
                  formControlName="_dictionary_description"
                  matInput
                  placeholder="Ex. The round fruit of a tree of the rose family"
                ></textarea>
                <!-- * Errors -->
                @if (desc1.hasError('maxlength')) {
                  <mat-error>
                    Maximum <strong>{{ _definitionMaxlength }}</strong> characters.
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <!-- * Note Container -->
            <div class="add-dialog-note-container" *ngIf="_selectedChipOptions.includes('note')">
              <div class="add-dialog-ai-container">
                <div class="ai-only-message">
                  <mat-icon>auto_awesome</mat-icon>
                  <p>You can also generate a note with Lingo AI.</p>
                </div>
                <ddc-button-ai
                  [_label]="'Generate Note with AI'"
                  [_mode]="'note'"
                  (click)="closeDialog()"
                ></ddc-button-ai>
              </div>
              <mat-divider style="margin: 12px 0"></mat-divider>
              <mat-form-field>
                <mat-label><mat-icon>title</mat-icon>&nbsp;&nbsp;Title</mat-label>
                <input formControlName="_note_title" matInput placeholder="Ex. My Study Notes" />
                @if (_form.get('_note_title')?.hasError('maxlength')) {
                  <mat-error>
                    Maximum <strong>{{ _noteTitleMaxlength }}</strong> characters.
                  </mat-error>
                }
              </mat-form-field>
              <mat-form-field>
                <mat-label><mat-icon>notes</mat-icon>&nbsp;&nbsp;Text</mat-label>
                <textarea
                  formControlName="_note_text"
                  matInput
                  placeholder="Write your note here..."
                  rows="6"
                ></textarea>
                @if (_form.get('_note_text')?.hasError('maxlength')) {
                  <mat-error>
                    Maximum <strong>{{ _noteTextMaxlength }}</strong> characters.
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <!-- * Quiz Container -->
            <div class="add-dialog-ai-container" *ngIf="_selectedChipOptions.includes('quiz')">
              <div class="ai-only-message">
                <mat-icon>info</mat-icon>
                <p>Quizzes can only be generated by Lingo AI. Click below to create one.</p>
              </div>
              <ddc-button-ai
                [_label]="'Generate Quiz with AI'"
                [_mode]="'quiz'"
                (click)="closeDialog()"
              ></ddc-button-ai>
            </div>
            <!-- * Figure Container -->
            <div class="add-dialog-ai-container" *ngIf="_selectedChipOptions.includes('figure')">
              <div class="ai-only-message">
                <mat-icon>info</mat-icon>
                <p>Figures can only be generated by Lingo AI. Click below to create one.</p>
              </div>
              <ddc-button-ai
                [_label]="'Generate Figure with AI'"
                [_mode]="'figure'"
                (click)="closeDialog()"
              ></ddc-button-ai>
            </div>
          </div>
        }
        <mat-divider
          *ngIf="!_wordCreated && !_pairCreated && !_noteCreated"
          style="margin-bottom: 10px; margin-top: 10px"
        ></mat-divider>

        <!-- ! Dictionary -->
        @if (
          _loadedDics &&
          !_hasDic &&
          !_wordCreated &&
          !_pairCreated &&
          !_noteCreated &&
          !_selectedChipOptions.includes('dictionary') &&
          !_selectedChipOptions.includes('note') &&
          !_selectedChipOptions.includes('quiz') &&
          !_selectedChipOptions.includes('figure')
        ) {
          <ddc-elem-chooser-one
            [_allElems]="_userDics"
            [_elemType]="'dictionary'"
            [_label]="'Dictionaries'"
            [_labelIcon]="'book'"
            [_placeholder]="'Add to dictionaries...'"
            [_type]="'multi'"
            (selectedElemsChange)="updateSelectedDics($event)"
          ></ddc-elem-chooser-one>
        }
        <!-- ! Privacy -->
        <mat-chip-listbox
          *ngIf="
            !_wordCreated &&
            !_pairCreated &&
            !_noteCreated &&
            !_selectedChipOptions.includes('dictionary') &&
            !_selectedChipOptions.includes('quiz') &&
            !_selectedChipOptions.includes('figure')
          "
          aria-label="privacy selection"
          formControlName="_privacy"
          [ngClass]="{
            'dark-theme': _isDarkTheme,
            'light-theme': _isLightTheme,
            'paper-theme': _isPaperTheme,
          }"
          [(ngModel)]="_selectedPrivacyChipOptions"
        >
          <mat-chip-option selected [value]="'P01'"><mat-icon matChipAvatar>public</mat-icon>Public</mat-chip-option>
          <mat-chip-option [value]="'P02'"><mat-icon matChipAvatar>group</mat-icon>Followers</mat-chip-option>
          <mat-chip-option [value]="'P03'"><mat-icon matChipAvatar>lock</mat-icon>Only Me</mat-chip-option>
        </mat-chip-listbox>
        <mat-divider
          *ngIf="
            !_wordCreated &&
            !_pairCreated &&
            !_noteCreated &&
            !_selectedChipOptions.includes('dictionary') &&
            !_selectedChipOptions.includes('quiz') &&
            !_selectedChipOptions.includes('figure')
          "
          style="margin-bottom: 10px; margin-top: 20px"
        ></mat-divider>
        <!-- ! Footer -->
        <div class="add-dialog-two-submit-container">
          <div class="add-dialog-submit-container-right">
            <button class="add-dialog-close-btn" mat-button type="button" (click)="closeDialog()">Cancel</button>
            <ddc-button-s-one
              *ngIf="
                !_wordCreated &&
                !_pairCreated &&
                !_noteCreated &&
                !_selectedChipOptions.includes('quiz') &&
                !_selectedChipOptions.includes('figure')
              "
              [_isLoading]="
                _selectedChipOptions.includes('note') ? _isNoteCreateLoading : CreateWordPairDicCommand.isExecuting
              "
              [_label]="_submitBtnText"
              [command]="_selectedChipOptions.includes('note') ? null : CreateWordPairDicCommand"
              [disabled]="!isFormValid()"
              (click)="_selectedChipOptions.includes('note') ? createNote() : closeDialog()"
            ></ddc-button-s-one>
          </div>
          <!-- @if (!_hasDic && !_isCreateBtnLoading && !_wordCreated && !_pairCreated) {
            <div class="add-dialog-submit-container-left">
              <ddc-button-s-two
                [_icon]="'add'"
                [_isLoading]="_isCreateBtnLoading"
                [_label]="'Create New Dictionary'"
                (click)="openAddDictionaryDialog()"
              ></ddc-button-s-two>
            </div>
          } -->
        </div>
      </form>
    </div>
  }
</div>
